import { useState, Dispatch, SetStateAction } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Segment, Table } from "semantic-ui-react";
import { toast } from "../..";
import { UserRole } from "../../actions/authentificationActions";
import { updateCompanyServiceType } from "../../api/companyServicesType";
import { TextInput } from "../../components/TextInput/TextInput";
import { ICompanyServiceType } from "../../models/companyServiceType";
import { AppState } from "../../store/configureStore";

interface IProps {
    companyServiceType: ICompanyServiceType;
    setCompanyServiceType: Dispatch<SetStateAction<ICompanyServiceType | undefined>>;
}

export const EditCompanyServiceType = ({ companyServiceType, setCompanyServiceType }: IProps) => {
    const history = useHistory();
    const user = useSelector((state: AppState) => state.user);
    const [saving, setSaving] = useState(false);
    const unauthorized = user.role !== UserRole.Admin;

    const handleCompanyServiceTypeUpdate = async () => {
        setSaving(true);
        try {
            await updateCompanyServiceType(companyServiceType);
            toast("Successfully saved changes", true);
            history.push("/administration/settings");
        } catch {
            toast("Failed to save changes, please try again", false);
        } finally {
            setSaving(false);
        }
    };

    const handleInputChange = (e: any) => {
        setCompanyServiceType({ ...companyServiceType, [e.target.name]: e.target.value });
    };

    const SaveButton = () =>
        !unauthorized ? (
            <Button
                secondary
                content="Save changes"
                icon="save"
                onClick={handleCompanyServiceTypeUpdate}
                disabled={saving || companyServiceType.type === ""}
                loading={saving}
            />
        ) : null;

    return (
        <Segment.Group>
            <Segment>
                <h2>Edit service type details</h2>
                <SaveButton />
            </Segment>
            <Segment>
                <Table basic="very" celled compact>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>Number</Table.Cell>
                            <Table.Cell>
                                <TextInput
                                    name="number"
                                    value={companyServiceType.number}
                                    handleInputChange={handleInputChange}
                                    disabled={unauthorized}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Service type</Table.Cell>
                            <Table.Cell>
                                <TextInput
                                    name="serviceType"
                                    value={companyServiceType.type}
                                    handleInputChange={handleInputChange}
                                    disabled={unauthorized}
                                />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </Segment>
            <Segment>
                <SaveButton />
            </Segment>
        </Segment.Group>
    );
};
